import { render, staticRenderFns } from "./modalTolak.vue?vue&type=template&id=89d39da6"
import script from "./modalTolak.vue?vue&type=script&lang=js"
export * from "./modalTolak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports